import { render, staticRenderFns } from "./withdraw.vue?vue&type=template&id=3add465c&scoped=true&"
import script from "./withdraw.vue?vue&type=script&lang=js&"
export * from "./withdraw.vue?vue&type=script&lang=js&"
import style0 from "./withdraw.vue?vue&type=style&index=0&id=3add465c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3add465c",
  null
  
)

export default component.exports